import { i18n } from '@/locales';
const lc = 'views.hub_management.';
const hubListTableHeader = [
    {
        title: i18n.t(`${lc}status`),
        align: 'center',
        sortable: true,
        key: 'useYn',
        width: 74,
    },
    {
        title: i18n.t(`${lc}name`),
        align: 'start',
        sortable: true,
        key: 'name',
        width: 190,
    },
    {
        title: i18n.t(`${lc}ceo_name`),
        align: 'start',
        sortable: false,
        key: 'ceoName',
        width: 100,
    },
    {
        title: i18n.t(`${lc}ceo_phone`),
        align: 'start',
        sortable: false,
        key: 'ceoPhone',
        width: 150,
    },
    {
        title: i18n.t(`${lc}business_number`),
        align: 'start',
        sortable: false,
        key: 'businessNumber',
        width: 140,
    },
    {
        title: i18n.t(`${lc}working_time`),
        align: 'start',
        sortable: false,
        key: 'workingTime',
        width: 136,
    },
    {
        title: i18n.t(`${lc}add_charge_apply_yn`),
        align: 'center',
        sortable: true,
        key: 'addChargeApplyYn',
        width: 110,
    },
    {
        title: i18n.t(`${lc}address`),
        align: 'start',
        sortable: false,
        key: 'addressRoad',
        width: 370,
    },
    {
        title: i18n.t(`${lc}virtual_bank_name`),
        align: 'start',
        sortable: false,
        key: 'virtualBankName',
        width: 184,
    },
    {
        title: i18n.t(`${lc}virtual_bank_account`),
        align: 'start',
        sortable: false,
        key: 'virtualBankAccount',
        width: 180,
    },
    {
        title: i18n.t(`${lc}baromoney`),
        align: 'end',
        sortable: true,
        key: 'baromoney',
        width: 170,
    },
    {
        title: i18n.t(`${lc}deposit_baromoney`),
        align: 'end',
        sortable: true,
        key: 'depositBaromoney',
        width: 170,
    },
    {
        title: i18n.t(`${lc}withdrawable_amount`),
        align: 'end',
        sortable: false,
        key: 'withdrawableAmount',
        width: 170,
    },
    {
        title: i18n.t(`${lc}created_at`),
        align: 'end',
        sortable: true,
        key: 'createdAt',
        width: 120,
    },
];
export const hubAdjustmentRateListTableHeader = {
    distributor: [
        {
            title: i18n.t('views.hub_management_detail.hub_adjustment_rate_name'),
            align: 'start',
            sortable: false,
            key: 'name',
            width: 126,
        },
        {
            title: i18n.t('common.headquarter'),
            align: 'end',
            sortable: false,
            key: 'headquarter',
            width: 126,
        },
        {
            title: i18n.t('common.distributor'),
            align: 'end',
            sortable: false,
            key: 'distributor',
            width: 126,
        },
        {
            title: i18n.t('common.hub'),
            align: 'end',
            sortable: false,
            key: 'hub',
            width: 126,
        },
    ],
    hub: [
        {
            title: i18n.t('views.hub_management_detail.hub_adjustment_rate_name'),
            align: 'start',
            sortable: false,
            key: 'name',
            width: 126,
        },
        {
            title: i18n.t('common.hub'),
            align: 'end',
            sortable: false,
            key: 'hub',
            width: 126,
        },
    ],
};
/**
 * 허브 상태
 * @param hubInfo
 * @returns
 */
export const getHubStatusContent = (hubInfo) => {
    const lcDetail = 'views.hub_management_detail.';
    if (!hubInfo) {
        return null;
    }
    return [
        {
            text: i18n.t(`${lcDetail}add_charge_use_yn`),
            value: hubInfo.formattedAddChargeApplyYn,
            textColor: 'brown darken-4',
            color: 'brown lighten-4',
        },
        {
            text: i18n.t('common.delivery_status'),
            value: hubInfo.getFulfillmentStateToText,
            textColor: 'green darken-4',
            color: 'green lighten-4',
        },
        {
            text: i18n.t(`${lcDetail}baromoney_balance`),
            value: hubInfo.formattedBaromoney,
            textColor: 'blue darken-4',
            color: 'blue lighten-4',
        },
    ];
};
export default hubListTableHeader;
